(function () {
  if (window.__sfaQuickAddInit) return;
  window.__sfaQuickAddInit = true;

  // Must match cart-notification.js getSectionsToRender() — max 5 sections per request.
  var NOTIFICATION_SECTIONS = ['cart-notification-product', 'cart-notification-free-ship', 'cart-notification-subtotal', 'cart-upsell', 'cart-icon-bubble'];

  function refreshCartBubble() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el || !sections['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var fresh = doc.getElementById('cart-icon-bubble');
        if (fresh) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.sfa-quick-add__btn') : null;
    if (!btn || btn.disabled) return;
    var wrap = btn.closest('[data-sfa-quick-add]');
    if (!wrap) return;
    e.preventDefault();
    e.stopPropagation();
    var sel = wrap.querySelector('.sfa-quick-add__select');
    var hid = wrap.querySelector('.sfa-quick-add__id');
    var id = sel ? sel.value : (hid ? hid.value : null);
    if (!id) return;
    var notification = document.querySelector('cart-notification');
    var useDrawer = !!(notification && typeof notification.renderContents === 'function');
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-adding-text') || 'Adding…';
    var payload = { items: [{ id: parseInt(id, 10), quantity: 1 }] };
    if (useDrawer) {
      payload.sections = NOTIFICATION_SECTIONS;
      payload.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (parsed) {
        btn.textContent = btn.getAttribute('data-added-text') || 'Added ✓';
        if (useDrawer && parsed && parsed.sections) {
          try {
            notification.renderContents(parsed);
          } catch (err) {
            refreshCartBubble();
          }
        } else {
          refreshCartBubble();
        }
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = original; }, 2500);
      });
  });
})();
